/**
 * Polyfills requestIdleCallback and cancelIdleCallback
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback
 */
export const polyfillRequestIdleCallback = () => {
    /* eslint-disable ssr-friendly/no-dom-globals-in-module-scope */
    window.requestIdleCallback =
        window.requestIdleCallback ||
        ((cb: IdleRequestCallback) => {
            const start = Date.now();
            return setTimeout(() => {
                cb({
                    didTimeout: false,
                    timeRemaining: () => Math.max(0, 50 - (Date.now() - start)),
                });
            }, 1);
        });

    window.cancelIdleCallback =
        window.cancelIdleCallback ||
        ((id: NodeJS.Timeout) => {
            clearTimeout(id);
        });
};
